import { Component } from '@angular/core';
import { AddToHomeScreenService } from '../../services/add-to-home-screen.service';
import { AddToHomeScreenComponent } from './../add-to-home-screen.component';

@Component({
  selector: 'cx-add-to-home-screen-banner',
  styleUrls: ['./add-to-home-screen-banner.component.scss'],
  templateUrl: './add-to-home-screen-banner.component.html'
})
export class AddToHomeScreenBannerComponent extends AddToHomeScreenComponent {
  constructor(protected addToHomeScreenService: AddToHomeScreenService) {
    super(addToHomeScreenService);
  }
}
